import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=53bc76ac&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=ts"
export * from "./SiteFooter.vue?vue&type=script&lang=ts"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=53bc76ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc76ac",
  null
  
)

export default component.exports